<template>
  <div>
    <bgcs
      :bgwindow="bgwindow"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <el-button v-preventReClick @click="bgwindow = !bgwindow">弹窗</el-button>
    <div class="block">
      <el-cascader
        v-model="value"
        :props="{ checkStrictly: true }"
        :options="options"
        @visible-change="showfunc"
        @change="handleChange"
      />
    </div>
    <!--  -->
    <div v-preventReClick @click="test" v-html="bgstring" />
    <!--  -->
  </div>
</template>

<script>
// 获取接口地址
import bgcs from '@/components/bgcs'

export default {
  name: 'Sjcz',
  components: {
    // sideMenu,
    // Header
    bgcs
  },
  data() {
    return {
      bgstring: '该单位2021-11-30 12:22:33 申请购买证（购买证编号：%GMZ%G21012120120#）和运输证（运输证编号：%YSZ%Y2121121212#）的购买入库数量（购买入库编号：%GMRK%GMRK425454524#）与销售出库数量（销售出库编号：%XSCK%XSCK215454545#）不一致。购买证编号：%GMZ%G21012120120#和购买入库编号：%GMRK%GMRK425454524#不一样，且运输证编号：%YSZ%Y2121121212#与销售出库编号：%XSCK%XSCK215454545#不一样。',
      bgwindow: false,
      value: [],
      options: [
        {
          value: 'zhinan',
          label: '指南',
          children: [
            {
              value: 'shejiyuanze',
              label: '设计原则',
              children: [
                {
                  value: 'yizhi',
                  label: '一致'
                },
                {
                  value: 'fankui',
                  label: '反馈'
                },
                {
                  value: 'xiaolv',
                  label: '效率'
                },
                {
                  value: 'kekong',
                  label: '可控'
                }
              ]
            },
            {
              value: 'daohang',
              label: '导航',
              children: [
                {
                  value: 'cexiangdaohang',
                  label: '侧向导航'
                },
                {
                  value: 'dingbudaohang',
                  label: '顶部导航'
                }
              ]
            }
          ]
        },
        {
          value: 'zujian',
          label: '组件',
          children: [
            {
              value: 'basic',
              label: 'Basic',
              children: [
                {
                  value: 'layout',
                  label: 'Layout 布局'
                },
                {
                  value: 'color',
                  label: 'Color 色彩'
                },
                {
                  value: 'typography',
                  label: 'Typography 字体'
                },
                {
                  value: 'icon',
                  label: 'Icon 图标'
                },
                {
                  value: 'button',
                  label: 'Button 按钮'
                }
              ]
            },
            {
              value: 'form',
              label: 'Form',
              children: [
                {
                  value: 'radio',
                  label: 'Radio 单选框'
                },
                {
                  value: 'checkbox',
                  label: 'Checkbox 多选框'
                },
                {
                  value: 'input',
                  label: 'Input 输入框'
                },
                {
                  value: 'input-number',
                  label: 'InputNumber 计数器'
                },
                {
                  value: 'select',
                  label: 'Select 选择器'
                },
                {
                  value: 'cascader',
                  label: 'Cascader 级联选择器'
                },
                {
                  value: 'switch',
                  label: 'Switch 开关'
                },
                {
                  value: 'slider',
                  label: 'Slider 滑块'
                },
                {
                  value: 'time-picker',
                  label: 'TimePicker 时间选择器'
                },
                {
                  value: 'date-picker',
                  label: 'DatePicker 日期选择器'
                },
                {
                  value: 'datetime-picker',
                  label: 'DateTimePicker 日期时间选择器'
                },
                {
                  value: 'upload',
                  label: 'Upload 上传'
                },
                {
                  value: 'rate',
                  label: 'Rate 评分'
                },
                {
                  value: 'form',
                  label: 'Form 表单'
                }
              ]
            },
            {
              value: 'data',
              label: 'Data',
              children: [
                {
                  value: 'table',
                  label: 'Table 表格'
                },
                {
                  value: 'tag',
                  label: 'Tag 标签'
                },
                {
                  value: 'progress',
                  label: 'Progress 进度条'
                },
                {
                  value: 'tree',
                  label: 'Tree 树形控件'
                },
                {
                  value: 'pagination',
                  label: 'Pagination 分页'
                },
                {
                  value: 'badge',
                  label: 'Badge 标记'
                }
              ]
            },
            {
              value: 'notice',
              label: 'Notice',
              children: [
                {
                  value: 'alert',
                  label: 'Alert 警告'
                },
                {
                  value: 'loading',
                  label: 'Loading 加载'
                },
                {
                  value: 'message',
                  label: 'Message 消息提示'
                },
                {
                  value: 'message-box',
                  label: 'MessageBox 弹框'
                },
                {
                  value: 'notification',
                  label: 'Notification 通知'
                }
              ]
            },
            {
              value: 'navigation',
              label: 'Navigation',
              children: [
                {
                  value: 'menu',
                  label: 'NavMenu 导航菜单'
                },
                {
                  value: 'tabs',
                  label: 'Tabs 标签页'
                },
                {
                  value: 'breadcrumb',
                  label: 'Breadcrumb 面包屑'
                },
                {
                  value: 'dropdown',
                  label: 'Dropdown 下拉菜单'
                },
                {
                  value: 'steps',
                  label: 'Steps 步骤条'
                }
              ]
            },
            {
              value: 'others',
              label: 'Others',
              children: [
                {
                  value: 'dialog',
                  label: 'Dialog 对话框'
                },
                {
                  value: 'tooltip',
                  label: 'Tooltip 文字提示'
                },
                {
                  value: 'popover',
                  label: 'Popover 弹出框'
                },
                {
                  value: 'card',
                  label: 'Card 卡片'
                },
                {
                  value: 'carousel',
                  label: 'Carousel 走马灯'
                },
                {
                  value: 'collapse',
                  label: 'Collapse 折叠面板'
                }
              ]
            }
          ]
        },
        {
          value: 'ziyuan',
          label: '资源',
          children: [
            {
              value: 'axure',
              label: 'Axure Components'
            },
            {
              value: 'sketch',
              label: 'Sketch Templates'
            },
            {
              value: 'jiaohu',
              label: '组件交互文档'
            }
          ]
        }
      ]
    }
  },
  created: function() {

  },
  mounted: function() {
    // 字符替换
    this.addLink()
  },
  methods: {
    // 字符替换
    addLink() {
      console.log('---')
      console.log(this.bgstring)
      // %GMZ%  购买证编号
      // %YSZ%  运输证编号
      // %GMRK%  购买入库编号
      // %XSCK%  销售出库编号
      // #  尾标签
      this.bgstring = this.bgstring.replace(/%GMZ%/g, '<span class="aaa" >')
      this.bgstring = this.bgstring.replace(/%YSZ%/g, '<span class="bbb" >')
      this.bgstring = this.bgstring.replace(/%GMRK%/g, '<span class="ccc" >')
      this.bgstring = this.bgstring.replace(/%XSCK%/g, '<span class="ddd" >')
      this.bgstring = this.bgstring.replace(/#/g, '</span>')

      console.log('---')
      console.log(this.bgstring)
    },
    test(event) {
      console.log(event.target.className) // testssss
      console.log(event.target.nodeName) // p
      if (event.target.className === 'aaa') {
        // 获取触发事件对象的属性
        alert('a')
      } else if (event.target.className === 'bbb') {
        // 获取触发事件对象的属性
        alert('b')
      } else if (event.target.className === 'ccc') {
        // 获取触发事件对象的属性
        alert('c')
      } else if (event.target.className === 'ddd') {
        // 获取触发事件对象的属性
        alert('d')
      }
    },

    // ////////////////////////////
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    handleChange(value) {
      console.log(value)
      // if(value.length<2){
      //   this.$message.error('至少选2级');
      // }
    },
    showfunc(e) {
      if (!e) {
        console.log(this.value.length)
        if (this.value.length < 2) {
          this.$message.error('至少选2级')
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/less" scoped>
.el-cascader-panel .el-radio {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 10px;
  right: 10px;
}
.el-cascader-panel .el-radio__input {
  visibility: hidden;
}
.el-cascader-panel .el-cascader-node__postfix {
  top: 10px;
}
</style>
